<template>
  <div>
    <BreadCrumd
      :title="'Configuration'"
      :description="'Informations sur la société/organisation'"
    />
    <div class="mt-4 mb-4">
      <form
        @submit.prevent="submit"
        @keydown="form.onKeydown($event)"
        enctype="multipart/form-data"
      >
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <b-tabs
              v-model="step"
              lazy
              active-nav-item-class="font-weight-bold text-custom-primary"
              content-class="mt-3"
            >
              <b-tab>
                <template slot="title">
                  <i class="fas fa-industry"></i> Société/Organisation
                  <span class="text-danger"> * </span>
                </template>

                <div class="row">
                  <div class="col-md-12 col-lg-3">
                    <div class="card mb-n1">
                      <div class="card-body mb-n2">
                        <div class="row">
                          <div class="col-12">
                            <div
                              class="d-flex flex-column align-items-center justify-content-center text-center"
                            >
                              <img
                                v-if="url_logo"
                                class="rounded-circle"
                                alt="Logo"
                                width="200"
                                height="200"
                                :src="url_logo"
                                data-holder-rendered="true"
                              />
                              <img
                                v-else
                                class="rounded-circle"
                                alt="Logo"
                                width="200"
                                height="200"
                                :src="URL_LOCAL_FILE + '/images/no-image.png'"
                                data-holder-rendered="true"
                              />
                              <div class="mt-3">
                                <p class="text-secondary mb-1">
                                  {{ form.raison_sociale }}
                                </p>
                                <div>
                                  <input
                                    ref="logoUpload"
                                    type="file"
                                    style="display: none"
                                    accept="image/*"
                                    :class="{
                                      'is-invalid': form.errors.has('logo'),
                                    }"
                                    @change="onChangeLogo"
                                  />
                                  <has-error
                                    :form="form"
                                    field="logo"
                                    class="mb-4"
                                  ></has-error>
                                </div>
                              </div>
                            </div>
                            <div
                              class="d-flex"
                              :class="
                                url_logo !== null
                                  ? 'justify-content-between'
                                  : 'justify-content-center'
                              "
                            >
                              <b-button
                                size="sm"
                                variant="outline-custom-primary"
                                @click="chooseLogo"
                                ><i class="fas fa-image" aria-hidden="true"></i>
                                Changer
                              </b-button>
                              <b-button
                                v-if="url_logo"
                                size="sm"
                                variant="outline-danger"
                                @click="onClearLogo"
                                ><i class="fas fa-trash" aria-hidden="true"></i>
                                Supprimer</b-button
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-9">
                    <div class="card">
                      <div class="card-body mb-n2">
                        <div class="row">
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="raison_sociale"
                                >Raison sociale
                                <span class="text-danger">*</span></label
                              >
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    form.errors.has('raison_sociale'),
                                }"
                                id="raison_sociale"
                                v-model="form.raison_sociale"
                                type="text"
                                placeholder="Raison sociale"
                                maxlength="50"
                              />
                              <has-error
                                :form="form"
                                field="raison_sociale"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="pays"
                                >Pays <span class="text-danger">*</span></label
                              >
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('pays'),
                                }"
                                id="pays"
                                v-model="form.pays"
                                type="text"
                                placeholder="Pays"
                                maxlength="50"
                              />
                              <has-error :form="form" field="pays"></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
                            <div class="form-group">
                              <label for="ville"
                                >Ville <span class="text-danger">*</span></label
                              >
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('ville'),
                                }"
                                id="ville"
                                v-model="form.ville"
                                type="text"
                                placeholder="Ville"
                                maxlength="50"
                              />
                              <has-error :form="form" field="ville"></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="immatriculation"
                                >Immatriculation
                              </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    form.errors.has('immatriculation'),
                                }"
                                id="immatriculation"
                                v-model="form.immatriculation"
                                type="text"
                                placeholder="Immatriculation"
                                maxlength="20"
                              />
                              <has-error
                                :form="form"
                                field="immatriculation"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="numero_tva">Numéro TVA </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('numero_tva'),
                                }"
                                id="numero_tva"
                                v-model="form.numero_tva"
                                type="text"
                                placeholder="Numéro TVA"
                                maxlength="20"
                              />
                              <has-error
                                :form="form"
                                field="numero_tva"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="capital">Capital </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('capital'),
                                }"
                                id="capital"
                                v-model.number="form.capital"
                                type="text"
                                placeholder="Capital"
                              />
                              <has-error
                                :form="form"
                                field="capital"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="devise"
                                >Devise principale
                                <span class="text-danger">*</span></label
                              >
                              <v-custom-select
                                label="symbole"
                                id="devise"
                                :options="devises"
                                :reduce="(devise) => devise.uuid"
                                v-model="form.devise"
                                placeholder="Devise par défaut"
                              >
                                <template v-slot:option="{ symbole }">
                                  <h5 style="margin: 0">{{ symbole }}</h5>
                                </template>
                                <template #no-options>
                                  Aucune données
                                </template>
                                <template #search="{ attributes, events }">
                                  <input
                                    id="devise"
                                    class="custom-select-height vs__search"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-custom-select>
                              <input
                                type="hidden"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('devise'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="devise"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="langue"
                                >Langue principale
                                <span class="text-danger">*</span></label
                              >
                              <v-custom-select
                                label="nom"
                                id="langue"
                                :options="langues"
                                :reduce="(langue) => langue.uuid"
                                v-model="form.langue"
                                placeholder="Langue"
                              >
                                <template v-slot:option="{ nom }">
                                  <h5 style="margin: 0">{{ nom }}</h5>
                                </template>
                                <template #no-options>
                                  Aucune données
                                </template>
                                <template #search="{ attributes, events }">
                                  <input
                                    id="type"
                                    class="custom-select-height vs__search"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-custom-select>
                              <input
                                type="hidden"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('langue'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="langue"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="adresse">Adresse </label>
                              <textarea
                                id="adresse"
                                v-model="form.adresse"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('adresse'),
                                }"
                                rows="5"
                                maxlength="150"
                              ></textarea>
                              <has-error
                                :form="form"
                                field="adresse"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="card-body mb-n2">
                        <div class="row">
                          <div class="col-md-8 col-lg-6">
                            <div class="form-group">
                              <label for="responsable"
                                >Responsable / DG / PDG
                              </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('responsable'),
                                }"
                                id="responsable"
                                v-model="form.responsable"
                                type="text"
                                placeholder="Responsable / DG / PDG"
                                maxlength="50"
                              />
                              <has-error
                                :form="form"
                                field="responsable"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-4 col-lg-3 mt-4 pt-3">
                            <div class="custom-control custom-checkbox mb-3">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="assujetti_tva"
                                v-model="form.assujetti_tva"
                              />
                              <label
                                class="custom-control-label"
                                for="assujetti_tva"
                                >Assujetti à la TVA ?</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="card-body mb-n2">
                        <div class="row">
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="telephone">Téléphone </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('telephone'),
                                }"
                                id="telephone"
                                v-model="form.telephone"
                                type="text"
                                placeholder="Téléphone"
                                maxlength="20"
                              />
                              <has-error
                                :form="form"
                                field="telephone"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="fax">Fax </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('fax'),
                                }"
                                id="fax"
                                v-model="form.fax"
                                type="text"
                                placeholder="Fax"
                                maxlength="20"
                              />
                              <has-error :form="form" field="fax"></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
                            <div class="form-group">
                              <label for="code_postal">Code postal </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('code_postal'),
                                }"
                                id="code_postal"
                                v-model="form.code_postal"
                                type="text"
                                placeholder="Code postal"
                                maxlength="20"
                              />
                              <has-error
                                :form="form"
                                field="code_postal"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4 mt-n4">
                            <div class="form-group">
                              <label for="email">Email </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('email'),
                                }"
                                id="email"
                                v-model="form.email"
                                type="email"
                                placeholder="Email"
                                maxlength="100"
                              />
                              <has-error :form="form" field="email"></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="fas fa-clock"></i> Heures d'ouverture
                </template>

                <div class="row">
                  <div class="col-12">
                    <p>
                      Entrez ici les heures d'ouverture régulières de votre
                      entreprise.
                    </p>
                  </div>
                </div>
                <div class="card">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Jour</th>
                        <th scope="col">Valeur</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(horaire, key) in horaires">
                        <tr :key="key">
                          <th scope="row">{{ key + 1 }}</th>
                          <td>
                            {{ horaire.libelle }}
                          </td>
                          <td>
                            <input
                              class="form-control form-control-sm"
                              style="max-width: 400px"
                              v-model="horaire.value"
                              type="text"
                              placeholder="Valeur"
                              @focus="$event.target.select()"
                            />
                          </td>
                        </tr>
                        <tr
                          class="error-tr text-center small"
                          :key="key + '-m-error'"
                          v-if="
                            form.errors.has('horaires.' + key + '.jour') ||
                            form.errors.has('horaires.' + key + '.value')
                          "
                        >
                          <td class="text-danger">
                            {{ form.errors.get('horaires.' + key + '.jour') }}
                          </td>
                          <td class="text-danger">
                            {{ form.errors.get('horaires.' + key + '.value') }}
                          </td>
                        </tr>
                      </template>

                      <tr v-if="horaires.length === 0">
                        <td class="text-center" colspan="3">Aucune données</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mb-4"></div>
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="fas fa-balance-scale"></i> Comptable
                </template>

                <div class="row">
                  <div class="col-12">
                    <p>
                      Si vous avez un comptable externe, vous pouvez saisir ici
                      ses informations.
                    </p>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body mb-n2">
                    <div class="row">
                      <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                          <label for="c_raison_sociale">Raison sociale </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_raison_sociale'),
                            }"
                            id="c_raison_sociale"
                            v-model="form.c_raison_sociale"
                            type="text"
                            placeholder="Raison sociale"
                            maxlength="50"
                          />
                          <has-error
                            :form="form"
                            field="c_raison_sociale"
                          ></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                          <label for="c_pays">Pays </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_pays'),
                            }"
                            id="c_pays"
                            v-model="form.c_pays"
                            type="text"
                            placeholder="Pays"
                            maxlength="50"
                          />
                          <has-error :form="form" field="c_pays"></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
                        <div class="form-group">
                          <label for="c_ville">Ville </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_ville'),
                            }"
                            id="c_ville"
                            v-model="form.c_ville"
                            type="text"
                            placeholder="Ville"
                            maxlength="50"
                          />
                          <has-error :form="form" field="c_ville"></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="c_telephone">Téléphone </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_telephone'),
                            }"
                            id="c_telephone"
                            v-model="form.c_telephone"
                            type="text"
                            placeholder="Téléphone"
                            maxlength="20"
                          />
                          <has-error
                            :form="form"
                            field="c_telephone"
                          ></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="c_fax">Fax </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_fax'),
                            }"
                            id="c_fax"
                            v-model="form.c_fax"
                            type="text"
                            placeholder="Fax"
                            maxlength="20"
                          />
                          <has-error :form="form" field="c_fax"></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="c_code_postal">Code postal </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_code_postal'),
                            }"
                            id="c_code_postal"
                            v-model="form.c_code_postal"
                            type="text"
                            placeholder="Code postal"
                            maxlength="20"
                          />
                          <has-error
                            :form="form"
                            field="c_code_postal"
                          ></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="c_email">Email </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_email'),
                            }"
                            id="c_email"
                            v-model="form.c_email"
                            type="email"
                            placeholder="Email"
                            maxlength="100"
                          />
                          <has-error :form="form" field="c_email"></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="c_code_comptable">Code comptable </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_code_comptable'),
                            }"
                            id="c_code_comptable"
                            v-model="form.c_code_comptable"
                            type="text"
                            placeholder="Code comptable"
                            maxlength="20"
                          />
                          <has-error
                            :form="form"
                            field="c_code_comptable"
                          ></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="c_adresse">Adresse </label>
                          <textarea
                            id="c_adresse"
                            v-model="form.c_adresse"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('c_adresse'),
                            }"
                            rows="5"
                            maxlength="150"
                          ></textarea>
                          <has-error :form="form" field="c_adresse"></has-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="row mt-2 mb-4">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/configuration/societe';
import { objectToFormData } from 'object-to-formdata';
import From from 'vform';
import config from '@/config';
export default {
  data() {
    return {
      form: new From({
        raison_sociale: '',
        pays: '',
        ville: '',
        immatriculation: '',
        numero_tva: '',
        capital: 0,
        devise: null,
        langue: null,
        adresse: '',
        responsable: '',
        telephone: '',
        fax: '',
        code_postal: '',
        email: '',

        c_raison_sociale: '',
        c_pays: '',
        c_ville: '',
        c_telephone: '',
        c_fax: '',
        c_code_postal: '',
        c_code_comptable: '',
        c_adresse: '',
      }),

      devises: [],
      langues: [],
      horaires: [],
      step: 0,
      url_logo: null,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      title: 'Configuration - Société',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  watch: {
    form() {
      this.form.clear();
    },
  },
  methods: {
    chooseLogo() {
      this.$refs.logoUpload.click();
    },
    onChangeLogo(e) {
      const file = e.target.files[0];
      this.form.logo = file;
      this.url_logo = global.URL.createObjectURL(file);
      this.form.clear_logo = false;
    },
    onClearLogo() {
      this.form.logo = null;
      this.url_logo = null;
      this.form.clear_logo = true;
    },

    init() {
      this.langues = [];
      this.devises = [];

      window.axios
        .all([
          window.axios.get(URL.SOCIETE),
          window.axios.get(URL.GET_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            Object.assign(this.form, resp1.data.societe);

            this.form.devise = this.form.devise.uuid;
            this.form.langue = this.form.langue.uuid;

            this.url_logo = this.form.url_logo;
            delete this.form.url_logo;

            this.horaires =
              this.form.horaires.length > 0
                ? this.form.horaires
                : this.$store.getters['app/defaultHoraires'];
            delete this.form.horaires;

            this.langues = resp2.data.langues;
            this.devises = resp2.data.devises;
          })
        )
        .catch();
    },
    submit() {
      this.form.horaires = JSON.stringify(this.horaires);
      this.form._method = 'PUT';
      this.form
        .post(URL.SOCIETE, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.$store.dispatch('app/loadSociete').then(() => {
            this.$currency.setConfig({
              symbol: this.$store.getters['app/societe'].devise.symbole,
              thousandsSeparator: ' ',
              fractionCount: 2,
              fractionSeparator: ',',
              symbolPosition: 'back',
              symbolSpacing: true,
            });
          });
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
          window._.forEach(err.response.data.errors, (_value, key) => {
            if (key.includes('contacts')) {
              this.step = 1;
            } else if (key.includes('banques')) {
              this.step = 2;
            } else if (key.includes('notes')) {
              this.step = 3;
            } else {
              this.step = 0;
            }
            return false;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
